__turbopack_context__.v({
  "animate": "CancelContent-module-scss-module__KIwDkq__animate",
  "bounce": "CancelContent-module-scss-module__KIwDkq__bounce",
  "hide": "CancelContent-module-scss-module__KIwDkq__hide",
  "show": "CancelContent-module-scss-module__KIwDkq__show",
});
